<template>
  <section class="section--comp">
    <div class="container items-center">
      <!--<h3 class="section__h3 mb-5">Designed for career experiences</h3>
      <p class="section__p mb-base">Activate Organization Mode to see how GetBoarded can help you and your employees to manage career choices keeping future in mind. A talent management tool with features that will convince you to use it as SaaS for your business.</p>-->
      <vs-row class="personality-row" vs-type="flex">
        <vs-col class="sm:w-full lg:w-1/2 p-1" vs-justify="center" vs-align="center">
          <div class="items-left">
            <div class="about-title mb-base">
              Agile in Microlearning
              – Why it’s the next
              big thing?
            </div>
            <div class="about-desc">
              <p class="mb-base">Agile in business refers to any approach to learning, development and training that emphasizes on speed, flexibility and teamwork. It is usually associated with software development but not limited to it.</p>
              <p class="mb-base"> Personalized Agile Microlearning can enhance productivity, drive success and ensure retention of important information.</p>
              <p class="mb-base"> It can be easily integrated into a company’s existing training program with measurable improvements.</p>
            </div>
            <div class="items-center">
              <img class="plant" src="../../../../../src/assets/images/pages/alex/about-leaf.png" width="100%" height="auto"/>
            </div>
          </div>
        </vs-col>
        <vs-col class="sm:w-full lg:w-1/2 p-5" vs-justify="center" vs-align="center">
          <vs-card class="w-full mb-base items-center">
            <div class="alex-content p-4 items-left">
              <div class="mb-3">Talent Mapping</div>
              <p>We know what to develop in our organization, but we know how to recognize who?</p>
            </div>
            <div class="alex-title p-5" @click="$router.push('/alex/connect')">
              Connect
            </div>
          </vs-card>
          <vs-card class="w-full mb-base items-center">
            <div class="alex-content p-4 items-left">
              <div class="mb-3">Training Need Analysis</div>
              <p>Training needs and performance management is it science or guess work?</p>
            </div>
            <div class="alex-title p-5" @click="$router.push('/alex/curate')">
              Curate
            </div>
          </vs-card>
          <vs-card class="w-full mb-base items-center">
            <div class="alex-content p-4 items-left">
              <div class="mb-3">Micro-Learning and Distributed Trainings</div>
              <p>How do we know our development gaps and encourage relevant periodic trainings</p>
            </div>
            <div class="alex-title p-5" @click="$router.push('/alex/customize')">
              Customize
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
  </section>
</template>

<script>
  export default {
    name: "About",
    data() {
      return {

      }
    }
  }
</script>

<style scoped>
  /*.items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }
  section {
    position: relative;
    padding: 5rem;
    background: #FFFFFF;
  }

  button {
    border-radius: 50px;
  }

  .section__h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 28px;
    text-align: center;
    color: #231D4F;
  }
  .section__p {
    width: 65%;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #848199;
  }*/
  .con-vs-card {
    height: unset;
    min-height: unset;
  }
  .con-vs-card >>> .vs-card--content {
    padding: 0! important;
  }

  .about-title {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 52px;
    text-transform: capitalize;
    color: #231D4F;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 20px;
  }

  .about-desc p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #848199;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 0px 20px;
  }

  .alex-title {
    background: rgba(220, 0, 50, 0.1);
    font-style: normal;
    font-weight: 600;
    font-size: 38px;
    line-height: 115%;
    text-transform: uppercase;
    color: #dc0032;
    border-radius: 0px 0px 8px 8px;
    cursor: pointer;
  }

  .alex-content div {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    display: flex;
    align-items: center;
    color: #231D4F;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 15px;
  }

  .alex-content p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #848199;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 0px 15px;
  }

  .feature-title {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 38px;

    flex: none;
    order: 0;
    align-self: flex-start;
    flex-grow: 0;
    margin: 0px 0px;
    color: #231D4F;
  }

  .feature-description {
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 20px;

    flex: none;
    order: 1;
    align-self: flex-start;
    flex-grow: 0;
    color: #848199;
  }

  .plant {
    width: 250px;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 5rem 0;
      background: #FFFFFF;
    }

    .about-title {
      font-size: 30px;
    }

    .alex-title {
      font-size: 28px;
    }
  }
</style>
